module.exports = __webpack_public_path__ + "static/media/Impreso-1-01.b4dc2d17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Impreso-1-01.jpg
// module id = 149
// module chunks = 0